// Route table (the xenquote console's). /login, /auth/callback and /invite are public;
// everything else needs a session and renders inside the AppShell (top bar + side nav).
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { AppShell } from "./components/AppShell";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { BuildingPage } from "./pages/BuildingPage";
import { CoveragePage } from "./pages/CoveragePage";
import { Dashboard } from "./pages/Dashboard";
import { FindBuildingsPage } from "./pages/FindBuildingsPage";
import { InvitePage } from "./pages/InvitePage";
import { LoginPage } from "./pages/LoginPage";
import { MyBuildingPage } from "./pages/MyBuildingPage";
import { MyBuildingsPage } from "./pages/MyBuildingsPage";
import { Placeholder } from "./pages/Placeholder";
import { PricingPage } from "./pages/PricingPage";
import { ProfilePage } from "./pages/ProfilePage";
import { RequestBuildingPage } from "./pages/RequestBuildingPage";
import { UsersPage } from "./pages/UsersPage";
import { navItems } from "./sections";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      {/* The link in an invite email (no sign-in): set a password and join the company */}
      <Route path="/invite" element={<InvitePage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="find" element={<FindBuildingsPage />} />
        <Route path="find/:ref" element={<BuildingPage />} />
        <Route path="properties" element={<MyBuildingsPage />} />
        <Route path="targets/request" element={<RequestBuildingPage />} />
        <Route path="properties/:orderId" element={<MyBuildingPage />} />
        {/* Old addresses (before Buildings became Properties) */}
        <Route path="buildings" element={<Navigate to="/properties" replace />} />
        <Route path="buildings/:orderId" element={<OldBuildingLink />} />
        <Route path="coverage" element={<CoveragePage />} />
        <Route path="filters" element={<CoveragePage part="filters" />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="users" element={<UsersPage />} />

        {/* Sections still to be built ("soon" items have no route) */}
        {navItems
          .filter((i) => !i.custom && !i.soon)
          .map((i) => (
            <Route key={i.path} path={i.path} element={<Placeholder title={i.label} blurb={i.blurb} />} />
          ))}
        {/* Unknown paths go back to the dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}

/** /buildings/<orderId> → /properties/<orderId> */
function OldBuildingLink() {
  const { orderId = "" } = useParams();
  return <Navigate to={`/properties/${encodeURIComponent(orderId)}`} replace />;
}
